"use strict";

module.exports = require("./OneDrive.js");